import React, { useRef } from 'react';

import { Header, Meta } from '$partials/global';
import { ModuleDispatcher } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HomePage}
 */
const HomePage = (props) => {
    const page = props.data.page;
    const bodyRef = useRef();
    return (
        <>
            <Meta
                description={page.searchDescription || page.listingText}
                domain={props.domain}
                image={page.metaImage || page.listingImage}
                page={page}
                title='INK' />
            <Header
                {...props.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}
                isHomepage={true}/>

            <main
                id='main-content'
                ref={bodyRef}>
                {page?.layout?.length > 0 && (
                    <section className='bg-[white] z-10 relative'>
                        {page.layout.map((module, i) => (
                            <ModuleDispatcher
                                {...module}
                                key={i + module?.id}/>
                        ))}
                    </section>
                )}
            </main>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HomePage;
